/* =========================================================
   ToyVerse Theme — Main JS
   Mobile menu, cart drawer (AJAX), search toggle, scroll
   reveal animations, quantity steppers, product options,
   testimonial slider, back-to-top, feedback stars.
========================================================= */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initMobileMenu();
    initSearchToggle();
    initCartDrawer();
    initScrollReveal();
    initBackToTop();
    initQuantitySteppers();
    initProductOptions();
    initTestimonialSlider();
    initFeedbackStars();
    initStickyHeaderShadow();
  });

  /* ---------------- Mobile Menu ---------------- */
  function initMobileMenu() {
    var toggle = document.getElementById("MobileMenuToggle");
    var menu = document.getElementById("MobileMenu");
    if (!toggle || !menu) return;

    function open() {
      menu.setAttribute("aria-hidden", "false");
      toggle.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
    }
    function close() {
      menu.setAttribute("aria-hidden", "true");
      toggle.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
    }
    toggle.addEventListener("click", open);
    menu.querySelectorAll("[data-menu-close]").forEach(function (el) {
      el.addEventListener("click", close);
    });
  }

  /* ---------------- Search Toggle ---------------- */
  function initSearchToggle() {
    var btn = document.getElementById("SearchToggle");
    var panel = document.getElementById("SearchPanel");
    if (!btn || !panel) return;
    btn.addEventListener("click", function () {
      panel.classList.toggle("open");
      if (panel.classList.contains("open")) {
        var input = panel.querySelector("input[type=search]");
        if (input) setTimeout(function () { input.focus(); }, 150);
      }
    });
  }

  /* ---------------- Cart Drawer (AJAX) ---------------- */
  function initCartDrawer() {
    var drawer = document.getElementById("CartDrawer");
    var openBtn = document.getElementById("CartToggle");
    if (!drawer) return;

    function openDrawer() {
      drawer.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      refreshCartDrawer();
    }
    function closeDrawer() {
      drawer.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
    if (openBtn) openBtn.addEventListener("click", openDrawer);
    drawer.querySelectorAll("[data-cart-close]").forEach(function (el) {
      el.addEventListener("click", closeDrawer);
    });

    // Intercept product forms for AJAX add-to-cart
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (form.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        var formData = new FormData(form);
        fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            openDrawer();
          })
          .catch(function () {
            form.submit();
          });
      }
    });

    // Quick add buttons on product cards
    document.addEventListener("click", function (e) {
      var quickAdd = e.target.closest("[data-quick-add]");
      if (quickAdd) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = quickAdd.getAttribute("data-variant-id");
        if (!variantId) return;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        })
          .then(function (r) { return r.json(); })
          .then(function () { openDrawer(); })
          .catch(function () {});
      }
    });
  }

  function refreshCartDrawer() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = document.getElementById("CartDrawerBody");
        var subtotal = document.getElementById("CartDrawerSubtotal");
        var count = document.getElementById("CartCount");
        if (count) count.textContent = cart.item_count;
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        if (!body) return;

        if (cart.item_count === 0) {
          body.innerHTML = '<div class="cart-drawer__empty">Your toy box is empty 🧸<br>Let\'s find something fun!</div>';
          return;
        }
        body.innerHTML = cart.items
          .map(function (item) {
            return (
              '<div class="cart-drawer__line">' +
              '<img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '">' +
              '<div><strong>' + escapeHtml(item.product_title) + "</strong><br>" +
              "Qty: " + item.quantity + " · " + formatMoney(item.final_price) +
              "</div></div>"
            );
          })
          .join("");
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
   return "BHD " + (cents / 100).toFixed(3);  // ✅ new — BHD with 3 decimals
  }
  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---------------- Scroll Reveal ---------------- */
  function initScrollReveal() {
    var items = document.querySelectorAll(".reveal-up");
    if (!("IntersectionObserver" in window) || items.length === 0) {
      items.forEach(function (el) { el.classList.add("in-view"); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    items.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------- Back to top ---------------- */
  function initBackToTop() {
    var btn = document.getElementById("BackToTop");
    if (!btn) return;
    window.addEventListener("scroll", function () {
      if (window.scrollY > 500) btn.classList.add("visible");
      else btn.classList.remove("visible");
    });
    btn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  /* ---------------- Sticky header shadow on scroll ---------------- */
  function initStickyHeaderShadow() {
    var header = document.getElementById("SiteHeader");
    if (!header) return;
    window.addEventListener("scroll", function () {
      if (window.scrollY > 10) header.style.boxShadow = "0 4px 18px rgba(0,0,0,.1)";
      else header.style.boxShadow = "0 2px 12px rgba(0,0,0,.06)";
    });
  }

  /* ---------------- Quantity steppers ---------------- */
  function initQuantitySteppers() {
    document.addEventListener("click", function (e) {
      var minus = e.target.closest("[data-quantity-minus]");
      var plus = e.target.closest("[data-quantity-plus]");
      if (!minus && !plus) return;
      var wrapper = (minus || plus).closest(".product-page__quantity-stepper");
      if (!wrapper) return;
      var input = wrapper.querySelector("input[type=number]");
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      if (minus) val = Math.max(1, val - 1);
      if (plus) val = val + 1;
      input.value = val;
    });
  }

  /* ---------------- Product option pills ---------------- */
  function initProductOptions() {
    var pills = document.querySelectorAll(".product-page__option-pill");
    if (!pills.length) return;

    var dataEl = document.getElementById("ProductVariantData");
    var variants = [];
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    }

    var idInput = document.getElementById("ProductVariantId");
    var mainImg = document.getElementById("ProductMainImage");
    var priceCurrent = document.querySelector(".product-page__price--current");

    function selectedValues() {
      var values = [];
      document.querySelectorAll(".product-page__option").forEach(function (group, i) {
        var sel = group.querySelector(".product-page__option-pill.selected");
        values[i] = sel ? sel.getAttribute("data-value") : null;
      });
      return values;
    }

    function findVariant(values) {
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        if (v.options.length !== values.length) continue;
        var match = true;
        for (var i = 0; i < values.length; i++) {
          if (v.options[i] !== values[i]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function updateVariant() {
      var values = selectedValues();
      if (values.indexOf(null) !== -1) return;
      var variant = findVariant(values);
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (variant.featured_image && mainImg) {
        mainImg.src = variant.featured_image;
        var target = variant.featured_image.split("?")[0];
        document.querySelectorAll(".product-page__thumb").forEach(function (t) {
          var full = (t.getAttribute("data-full") || "").split("?")[0];
          t.classList.toggle("active", full === target);
        });
      }

      if (priceCurrent && variant.price) priceCurrent.textContent = variant.price;
    }

    pills.forEach(function (pill) {
      pill.addEventListener("click", function () {
        var group = pill.closest(".product-page__option");
        if (group) {
          group.querySelectorAll(".product-page__option-pill").forEach(function (p) {
            p.classList.remove("selected");
          });
        }
        pill.classList.add("selected");
        updateVariant();
      });
    });

    // Pre-select pills matching the initial variant
    var initialId = idInput ? String(idInput.value) : "";
    var initial = null;
    for (var k = 0; k < variants.length; k++) {
      if (String(variants[k].id) === initialId) { initial = variants[k]; break; }
    }
    if (!initial && variants.length) initial = variants[0];
    if (initial) {
      document.querySelectorAll(".product-page__option").forEach(function (group, i) {
        var want = initial.options[i];
        group.querySelectorAll(".product-page__option-pill").forEach(function (p) {
          if (p.getAttribute("data-value") === want) p.classList.add("selected");
        });
      });
    }
  }

  /* ---------------- Testimonial slider ---------------- */
  function initTestimonialSlider() {
    var slider = document.getElementById("TestimonialsSlider");
    var prev = document.getElementById("TestimonialPrev");
    var next = document.getElementById("TestimonialNext");
    if (!slider || !prev || !next) return;
    var scrollAmount = 320;
    prev.addEventListener("click", function () {
      slider.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });
    next.addEventListener("click", function () {
      slider.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });
  }

  /* ---------------- Feedback star rating input ---------------- */
  function initFeedbackStars() {
    var container = document.querySelector("[data-star-rating]");
    var ratingInput = document.getElementById("RatingInput");
    if (!container || !ratingInput) return;
    var stars = container.querySelectorAll(".feedback-form__star");
    function setRating(value) {
      stars.forEach(function (star, idx) {
        star.classList.toggle("active", idx < value);
      });
      ratingInput.value = value;
    }
    setRating(5);
    stars.forEach(function (star) {
      star.addEventListener("click", function () {
        setRating(parseInt(star.getAttribute("data-star"), 10));
      });
    });
  }
})();

/* ---------------- Product gallery (thumbs + prev/next) ---------------- */
document.addEventListener("DOMContentLoaded", function () {
  initProductGallery();
  initFilterToggle();
  initFilterGroupCollapse();
  initStickyBar();
});

function initProductGallery() {
  var thumbs = document.querySelectorAll(".product-page__thumb");
  var mainImg = document.getElementById("ProductMainImage");
  var prevBtn = document.getElementById("GalleryPrev");
  var nextBtn = document.getElementById("GalleryNext");
  if (!mainImg || thumbs.length === 0) return;

  var current = 0;

  function setActive(index) {
    if (index < 0) index = thumbs.length - 1;
    if (index >= thumbs.length) index = 0;
    current = index;
    thumbs.forEach(function (t) { t.classList.remove("active"); });
    thumbs[current].classList.add("active");
    mainImg.src = thumbs[current].getAttribute("data-full");
  }

  thumbs.forEach(function (thumb, idx) {
    thumb.addEventListener("click", function () { setActive(idx); });
  });
  if (prevBtn) prevBtn.addEventListener("click", function () { setActive(current - 1); });
  if (nextBtn) nextBtn.addEventListener("click", function () { setActive(current + 1); });
}

/* ---------------- Collection filter mobile toggle ---------------- */
function initFilterToggle() {
  var toggle = document.getElementById("FiltersToggle");
  var panel = document.getElementById("FiltersPanel");
  if (!toggle || !panel) return;
  toggle.addEventListener("click", function () {
    panel.classList.toggle("open");
  });
}

/* ---------------- Filter group collapse/expand ---------------- */
function initFilterGroupCollapse() {
  document.querySelectorAll("[data-filter-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.closest(".collection-filters__group");
      if (!group) return;
      var collapsed = group.getAttribute("data-collapsed") === "true";
      group.setAttribute("data-collapsed", collapsed ? "false" : "true");
      btn.setAttribute("aria-expanded", collapsed ? "true" : "false");
    });
  });
}

/* ---------------- Sticky add-to-cart bar ---------------- */
function initStickyBar() {
  var bar = document.getElementById("ProductStickyBar");
  var mainForm = document.querySelector('form[action*="/cart/add"]');
  var stickyBtn = document.getElementById("StickyAddToCart");
  if (!bar) return;

  var actionsEl = document.querySelector(".product-page__actions");
  if (actionsEl && "IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) bar.classList.remove("visible");
          else if (entry.boundingClientRect.top < 0) bar.classList.add("visible");
          else bar.classList.remove("visible");
        });
      },
      { threshold: 0 }
    );
    observer.observe(actionsEl);
  }

  if (stickyBtn && mainForm) {
    stickyBtn.addEventListener("click", function () {
      mainForm.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
    });
  }
}

/* ---------------- Buy It Now: add to cart, then go straight to checkout ---------------- */
document.addEventListener("DOMContentLoaded", function () {
  initBuyNow();
});

function initBuyNow() {
  document.querySelectorAll("[data-buy-now]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var form = btn.closest("form");
      if (!form) return;

      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding...";

      var formData = new FormData(form);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { Accept: "application/json" },
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw new Error(err.description || "Could not add to cart");
            });
          }
          return response.json();
        })
        .then(function () {
          window.location.href = "/checkout";
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = originalText;
          alert(err.message || "Something went wrong. Please try again.");
        });
    });
  });
}
